var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.362.415a1.14 1.14 0 0 1 1.612 0L6.3 4.746l4.326-4.33a1.14 1.14 0 1 1 1.613 1.614L7.913 6.36l4.326 4.331a1.143 1.143 0 0 1-.811 1.935 1.14 1.14 0 0 1-.802-.32L6.3 7.975l-4.326 4.33a1.14 1.14 0 0 1-1.612-1.614l4.325-4.33L.362 2.03a1.14 1.14 0 0 1 0-1.615"
  })));
};
export default SvgClose;